// extracted by mini-css-extract-plugin
module.exports = {"controls":"newDeckForm_controls__I8v7T","flags":"newDeckForm_flags__P9fVi"};